import React from "react";
import { FaArrowRight } from "react-icons/fa6";
import { BTN_SIZE, Container, H1_SIZE } from "../home/ui";

// Full-width hero background (designer at a desk on the right, empty space on the left for the text).
// On desktop (xl+) it covers the whole section; on mobile/tablet the illustration part shows below the text.
const sectionBg = "/img/what-we-do-bg1.jpg";

// NOTE: keep these numbers accurate for DataMetricks (same figures as the home page hero).
const stats = [
  { value: "100+", label: "Projects Delivered", tone: "text-[#0B0D2C]" },
  { value: "50+", label: "Happy Clients", tone: "text-[#3D5BF6]" },
  { value: "4.9/5", label: "Client Rating", tone: "text-[#6D28D9]" },
];

const UiuxHero = () => (
  <section
    className="relative overflow-hidden bg-[#F8F8FF] bg-no-repeat pb-[48px] pt-[110px] xl:flex xl:min-h-[min(38vw,720px)] xl:items-center xl:bg-[image:var(--hero-bg)] xl:bg-cover xl:bg-right xl:pb-[40px] xl:pt-[calc(clamp(76px,5.83vw,112px)+24px)]"
    style={{ "--hero-bg": `url(${sectionBg})` }}
  >
    <Container className="relative grid w-full max-w-[1900px] items-center gap-[32px] xl:grid-cols-[minmax(0,44%)_1fr] xl:pl-[clamp(32px,4.375vw,84px)] xl:pr-[clamp(24px,3.125vw,60px)]">
      <div className="m-hero">
        <span className="inline-flex items-center rounded-full bg-[#ECEBFF] px-[16px] py-[6px] text-[13px] font-semibold uppercase tracking-[0.04em] text-[#3B2A8F]">
          UI/UX Design
        </span>

        <h1 className={`mt-[18px] font-extrabold tracking-tight text-[#0B0D2C] ${H1_SIZE}`}>
          Design Experiences
          {" "}<br />
          <span className="bg-gradient-to-r from-[#3D5BF6] to-[#A855F7] bg-clip-text text-transparent">People Love</span>
        </h1>

        <p className="mt-[18px] max-w-[520px] text-[16px] leading-[1.6] text-slate-600 sm:text-[17px] xl:text-[clamp(15px,1.05vw,18px)]">
          We create user-centric UI/UX designs that are beautiful, intuitive and drive real business results.
        </p>

        <div className="m-btns mt-[28px] flex flex-wrap items-center gap-[16px]">
          <a
            href="/contact-us"
            className={`group inline-flex items-center rounded-full bg-gradient-to-r from-[#3D4BF6] to-[#7C3AED] font-medium text-white shadow-[0_14px_30px_-14px_rgba(91,61,245,0.75)] transition hover:brightness-110 ${BTN_SIZE}`}
          >
            Discuss Your Project
            <FaArrowRight className="text-[13px] transition group-hover:translate-x-1" />
          </a>
          <a
            href="/our-completed-projects"
            className={`inline-flex items-center rounded-full border-[1.5px] border-solid border-[#8B7CF6] bg-white/70 font-medium text-[#3B2A8F] transition hover:bg-[#F1EEFF] ${BTN_SIZE}`}
          >
            View Our Work
          </a>
        </div>

        <div className="mt-[36px] flex flex-wrap gap-x-[28px] gap-y-[18px] sm:gap-x-[56px]">
          {stats.map((s) => (
            <div key={s.label}>
              <p className={`text-[26px] font-bold leading-none ${s.tone}`}>{s.value}</p>
              <p className="mt-[8px] text-[13.5px] text-slate-500">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="xl:hidden">
        <img
          src={sectionBg}
          alt="Designer working on a mobile app UI at her desk"
          className="aspect-[4/3] h-auto w-full select-none rounded-[20px] object-cover object-[78%_center]"
        />
      </div>
    </Container>
  </section>
);

export default UiuxHero;
